module.exports = __webpack_public_path__ + "img/heading_no.a9930a5c.svg";